export enum UserType {
  SUPER_ADMIN = 'super_admin',
  ADMIN = 'admin',
  EMPLOYEE = 'employee',
  PARTNER = 'partner',
  PARTNER2 = 'partner2',
  SELLER = 'seller',
  SELLER_ADMIN = 'seller_admin',
  SUPERVISOR = 'supervisor',
  CLIENT = 'client',
}
